import React, {Component} from 'react';
import {connect} from 'react-redux';
import webp from '../../utils/webp';
import { observer, inject } from "mobx-react"

class LazyBg extends Component {
  componentDidMount() {
    if("IntersectionObserver" in window) {
      this.observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            const {isIntersecting} = entry;
            if (isIntersecting || typeof isIntersecting === 'undefined') {
              if(this.element) {
                this.element.style.backgroundImage = webp(this, this.props.style.backgroundImage);
                this.observer = this.observer.disconnect();
              }
            }
          });
        },
        {
          //root: document.querySelector(".container"),
          rootMargin: "200px 0px 200px 0px"
        }
      );
      this.observer.observe(this.element);
    } else {
      this.element.style.backgroundImage = this.props.style.backgroundImage;
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevProps.style.backgroundImage !== this.props.style.backgroundImage) {
      this.element.style.backgroundImage = webp(this,this.props.style.backgroundImage);
      //this.element.src = webp(this,this.props.src);
    }
  }
  getStyle() {
    if(this.props.style) {
      const newStyle={};
      for(let i in this.props.style) {
        if(i !== 'backgroundImage')
        newStyle[i]=this.props.style[i];
      }
      return newStyle;
    }
    return {};
  }
  render() {
    return (
      <div ref={el => this.element = el} className={this.props.className} style={this.getStyle()}>
        {this.props.children}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    webp:state.webp,
  }
}

export default observer(LazyBg);